import styled from 'styled-components';
import { colors } from '../../../theme/colors';

const getSpacingMd = (props) => (props.theme && props.theme.spacing && props.theme.spacing.md) || '16px';
const getSpacingXs = (props) => (props.theme && props.theme.spacing && props.theme.spacing.xs) || '4px';
const getFontSizeSm = (props) => (props.theme && props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.sm) || '14px';
const getFontSizeXs = (props) => (props.theme && props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.xs) || '12px';
const getTextMuted = (props) => (props.theme && props.theme.colors && props.theme.colors.text && props.theme.colors.text.muted) || '#999';

export const StepsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: ${props => getSpacingMd(props)} 0;
  overflow-x: auto;
`;

export const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
  min-width: 120px;

  &:not(:last-child):after {
    content: '';
    position: absolute;
    top: 16px;
    left: calc(50% + 20px);
    right: calc(-50% + 20px);
    height: 2px;
    background-color: ${props => (props.isCompleted ? colors.success : colors.brandOffWhite)};
    z-index: 1;
    transition: background-color 0.3s ease;
  }
`;

export const StepCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: all 0.3s ease;
  font-weight: bold;
  font-size: ${props => getFontSizeSm(props)};

  background-color: ${props => {
    if (props.status === 'completed') return colors.success;
    if (props.status === 'active') return colors.brandDarkBlue;
    return colors.white || '#fff';
  }};

  border: 2px solid ${props => {
    if (props.status === 'completed') return colors.success;
    if (props.status === 'active') return colors.brandDarkBlue;
    return colors.brandLightGray;
  }};

  color: ${props => {
    if (props.status === 'completed') return '#fff';
    if (props.status === 'active') return '#fff';
    return colors.brandLightGray;
  }};
`;

export const StepLabel = styled.div`
  margin-top: ${props => getSpacingXs(props)};
  text-align: center;
`;

export const Title = styled.div`
  font-size: ${props => getFontSizeSm(props)};
  font-weight: ${props => (props.active ? 'bold' : 'normal')};
  color: ${props => (props.active ? colors.brandDarkBlue : colors.brandMediumGray)};
`;

export const Description = styled.div`
  font-size: ${props => getFontSizeXs(props)};
  color: ${props => getTextMuted(props)};
  margin-top: 2px;
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Steps/components/StepsStyles.js